import { render } from "./GapsView.vue?vue&type=template&id=96cd5a76"
import script from "./GapsView.vue?vue&type=script&lang=js"
export * from "./GapsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__